import React, { Fragment, Component } from 'react';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "@import url('https://fonts.googleapis.com/css2?family=NTR&display=swap');\n\nbody {\n    margin: 0;\n    overflow-x: hidden;\n  }\n  \n  html * {\n    font-family: 'Open Sans', sans-serif !important;\n  }\n  \n  .container {\n    margin: auto;\n  }\n  \n  .header-block,\n  .site-header--static-header-type {\n      padding-top: 50px;\n      padding-bottom: 50px;\n      background-color: transparent;\n  }\n  \n  .header-bottom-border .header-block {\n      border-bottom: 1px solid #f3f3f3\n  }\n  \n  .header-block {\n      display: flex;\n      flex-direction: column;\n      box-shadow: 2px 1px 2px 1px rgba(0, 0, 0, 0.2);\n  }\n  \n  @media screen and (max-width:768px) {\n      .header-block {\n          padding-top: 25px;\n          padding-bottom: 25px\n      }\n  }\n  \n  .header-block__row {\n      display: flex;\n      margin-left: -15px;\n      margin-right: -15px;\n      flex-grow: 1;\n      flex-wrap: wrap\n  }\n  \n  .header-block__row-container {\n      display: flex;\n      flex-direction: column;\n      width: 100%;\n  }\n  \n  .header-block__column {\n      display: flex;\n      padding-left: 15px;\n      padding-right: 15px;\n      width: 100%;\n      flex-basis: 0;\n      flex-grow: 1;\n      min-width: 0;\n      max-width: 100%\n  }\n  \n  .header-block__logo {\n      align-items: center\n  }\n  \n  .header-block__items-row {\n      display: flex;\n      flex-direction: row;\n      margin-left: -15px;\n      margin-right: -15px\n  }\n  \n  @media screen and (max-width:768px) {\n      .header-block__items-row {\n          margin-left: -10px;\n          margin-right: -10px\n      }\n  }\n  \n  .header-block__items-row .header-block__item {\n      /* padding-left: 15px; */\n      padding-right: 15px\n  }\n  \n  @media screen and (max-width:768px) {\n      .header-block__items-row .header-block__item {\n          /* padding-left: 10px; */\n          padding-right: 10px\n      }\n  }\n  \n  .header-block__item {\n      display: flex;\n      align-items: center\n  }\n  \n  .header-block__item .textwidget p:last-child {\n      margin-bottom: 0\n  }\n  \n  .header-block__item .social-network-link {\n      margin-bottom: 0\n  }\n  \n  @media screen and (min-width:992px) {\n      .header-block__item--hide-on-desktop {\n          display: none\n      }\n  }\n  \n  @media screen and (min-width:768px) and (max-width:991px) {\n      .header-block__item--hide-on-tablet {\n          display: none\n      }\n  }\n  \n  @media screen and (max-width:767px) {\n      .header-block__item--hide-on-mobile {\n          display: none\n      }\n  }\n  \n  .header-block--auto-grow {\n      flex: 0 0 auto;\n      width: auto\n  }\n  \n  .header-block--align-left {\n      justify-content: flex-start\n  }\n  \n  .header-block--align-center {\n      justify-content: center\n  }\n  \n  .header-block--align-right {\n      justify-content: flex-end\n  }\n  \n  .header-block--align-space-evenly {\n      justify-content: space-evenly\n  }\n  \n  .header-block--content-below .header-block__item {\n      margin-top: 30px\n  }\n  \n  .header-logo {\n      position: relative;\n      white-space: nowrap;\n      text-decoration: none;\n  }\n\n  .header-logo:hover {\n    text-decoration: none;\n  }\n  \n  .header-logo.logo-image {\n      position: relative;\n      display: block;\n  }\n  .header-logo span {\n      display: block;\n      margin-top: 0.3rem;\n      margin-bottom: -1.9rem;\n      color: #2c3142;\n  }\n\n  .header-logo span svg {\n      width: 12px;\n      vertical-align: middle;\n      margin-right: 0.3rem;\n  }\n  \n  .header-logo.logo-image img {\n      position: relative;\n      display: block;\n      z-index: 10;\n      width: 100%;\n      height: auto;\n      max-width: 100%\n  }\n  \n  .header-logo.logo-image img.alternate-logo {\n      position: absolute;\n      top: 0;\n      left: 0;\n      opacity: 0;\n      visibility: hidden\n  }\n  \n  .toggle-bars {\n      position: relative;\n      display: flex;\n      flex-direction: row;\n      padding: 5px 0;\n      z-index: 301\n  }\n  \n  .wrapper .toggle-bars {\n      display: flex\n  }\n  \n  .fullscreen-menu .fullscreen-menu-footer .social-networks li a span,\n  .single-post .post .post-share-networks--style-icons a span,\n  .single-post .post-image .post-gallery-images .flickity-prev-next-button svg,\n  .toggle-bars:after,\n  .wrapper .toggle-bars:after {\n      display: none\n  }\n  \n  .toggle-bars span {\n      display: none;\n  }\n  \n  .toggle-bars__column {\n      flex-grow: 1\n  }\n  \n  .toggle-bars__column--right {\n      order: 2\n  }\n  \n  .toggle-bars__column--padding-left {\n      padding-left: 10px\n  }\n  \n  .ninja-forms-form-wrap .ninja-forms-all-fields-wrap .field-wrap.label-left>label,\n  .toggle-bars__column--padding-right {\n      padding-right: 10px\n  }\n  \n  .toggle-bars__bar-lines {\n      position: relative;\n      width: 23px;\n      height: 18px\n  }\n  \n  .toggle-bars__bar-line {\n      position: absolute;\n      height: 2px;\n      left: 0;\n      width: 100%;\n      top: 50%;\n      margin-top: -1px;\n      background-color: #000;\n      transition: all 200ms ease\n  }\n  \n  .toggle-bars__bar-line--top {\n      top: 1px\n  }\n  \n  .toggle-bars__bar-line--bottom {\n      top: 100%;\n      margin-top: -2px\n  }\n  \n  .toggle-bars__text {\n      position: relative;\n      height: 18px;\n      line-height: 18px;\n      color: #000;\n      transition: all 250ms cubic-bezier(.445, .05, .55, .95)\n  }\n  \n  .toggle-bars__text--show {\n      transition-delay: 50ms\n  }\n  \n  .toggle-bars__text--hide {\n      margin-top: -18px;\n      transform: translateY(-8px);\n      visibility: hidden;\n      opacity: 0;\n      transition-delay: 0ms\n  }\n  \n  .toggle-bars.exit .toggle-bars__bar-line {\n      transform-origin: center\n  }\n  \n  .toggle-bars.exit .toggle-bars__bar-line--top {\n      top: 50%;\n      transform: rotate(-45deg)\n  }\n  \n  .toggle-bars.exit .toggle-bars__bar-line--middle {\n      opacity: 0\n  }\n  \n  .toggle-bars.exit .toggle-bars__bar-line--bottom {\n      top: 50%;\n      margin-top: -1px;\n      transform: rotate(45deg)\n  }\n  \n  .toggle-bars.exit .toggle-bars__text--show {\n      visibility: hidden;\n      opacity: 0;\n      transform: translateY(8px);\n      transition-delay: 0ms\n  }\n  \n  .toggle-bars.exit .toggle-bars__text--hide {\n      visibility: visible;\n      opacity: 1;\n      transform: translateY(0);\n      transition-delay: 50ms\n  }\n  \n  .toggle-bars.exit-arrow .toggle-bars__bar-line--top {\n      left: -50%;\n      transform: rotate(-45deg);\n      transform-origin: right top\n  }\n  \n  .toggle-bars.exit-arrow .toggle-bars__bar-line--middle {\n      opacity: 0\n  }\n  \n  .toggle-bars.exit-arrow .toggle-bars__bar-line--bottom {\n      top: 0;\n      left: 50%;\n      margin-top: 0;\n      transform: rotate(45deg);\n      transform-origin: left top\n  }\n  \n  .toggle-bars.exit-arrow .toggle-bars__text--show {\n      visibility: hidden;\n      opacity: 0;\n      transform: translateY(8px);\n      transition-delay: 0ms\n  }\n  \n  .toggle-bars.exit-arrow .toggle-bars__text--hide {\n      visibility: visible;\n      opacity: 1;\n      transform: translateY(0);\n      transition-delay: 50ms\n  }\n  \n  .standard-menu-container.menu-skin-main .menu>ul>li>a:after,\n  .standard-menu-container.menu-skin-main ul.menu>li>a:after,\n  .toggle-bars.menu-skin-main .toggle-bars__bar-line {\n      background-color: #2c3142;\n  }\n  \n  .standard-menu-container.menu-skin-main .menu>ul>li>a,\n  .standard-menu-container.menu-skin-main ul.menu>li>a,\n  .toggle-bars.menu-skin-main .toggle-bars__text {\n      color: #2c3142\n  }\n  \n  .toggle-bars.menu-skin-light .toggle-bars__bar-line {\n      background-color: #fff\n  }\n  \n  .standard-menu-container.menu-skin-main .menu>ul ul li a,\n  .standard-menu-container.menu-skin-main ul.menu ul li a,\n  .toggle-bars.menu-skin-light .toggle-bars__text {\n      color: #fff\n  }\n  \n  .standard-menu-container {\n      text-align: right\n  }\n  \n  .standard-menu-container .toggle-bars,\n  .standard-menu-container>nav {\n      align-self: center\n  }\n  \n  .standard-menu-container ul li a,\n  .standard-menu-container.dropdown-caret .menu>.menu-item-has-children>a>span {\n      text-decoration: none\n  }\n  \n  .standard-menu-container.dropdown-caret .menu>.menu-item-has-children>a>span:after {\n      position: relative;\n      font-family: Flaticon;\n      content: '\\e008';\n      margin-left: 8px;\n      font-size: 11px;\n      text-decoration: none;\n      line-height: 0;\n      top: -1px;\n      font-weight: 700\n  }\n  \n  .standard-menu-container ul {\n      list-style: none;\n      padding: 0;\n      margin: 0\n  }\n  \n  .standard-menu-container ul li {\n      padding: 0;\n      margin: 0\n  }\n \n  .standard-menu-container .menu>ul>li>a,\n  .standard-menu-container ul.menu>li>a {\n      color: #2c3142;\n      font-size: 16px\n  }\n  \n  .standard-menu-container .menu>ul>li>a:after,\n  .standard-menu-container ul.menu>li>a:after {\n      opacity: .8;\n      background-color: #2c3142\n  }\n  \n  .standard-menu-container .menu>ul>li+li,\n  .standard-menu-container ul.menu>li+li {\n      margin-left: 16px\n  }\n  \n  @media screen and (max-width:992px) {\n      .standard-menu-container .menu>ul>li+li,\n      .standard-menu-container ul.menu>li+li {\n          margin-left: 15px\n      }\n  }\n  \n  .standard-menu-container .menu>ul>li>ul li,\n  .standard-menu-container ul.menu>li>ul li {\n      /* overflow: hidden; */\n      padding-bottom: 1px\n  }\n  \n  .standard-menu-container .menu>ul>li>ul li.sub-visible,\n  .standard-menu-container ul.menu>li>ul li.sub-visible {\n      overflow: visible\n  }\n  \n  .standard-menu-container .menu>ul li,\n  .standard-menu-container ul.menu li {\n      position: relative\n  }\n  \n  .standard-menu-container .menu>ul li.sub-visible>ul,\n  .standard-menu-container ul.menu li.sub-visible>ul {\n      visibility: visible;\n      opacity: 1\n  }\n  \n  .change-search-keyword-wrapper.focused input[type=text],\n  .standard-menu-container .menu>ul li.sub-visible>ul>li>a,\n  .standard-menu-container ul.menu li.sub-visible>ul>li>a {\n      opacity: 1\n  }\n  \n  .standard-menu-container .menu>ul li>ul>li>a,\n  .standard-menu-container ul.menu li>ul>li>a {\n      opacity: 1;\n      transition: all 0ms cubic-bezier(.445, .05, .55, .95);\n      transition-duration: 120ms\n  }\n  \n  .standard-menu-container .menu>ul li>ul>li:nth-last-child(n+1)>a,\n  .standard-menu-container ul.menu li>ul>li:nth-last-child(n+1)>a {\n      transition-duration: 120ms\n  }\n  \n  .standard-menu-container .menu>ul li>ul>li:nth-last-child(n+2)>a,\n  .standard-menu-container ul.menu li>ul>li:nth-last-child(n+2)>a {\n      transition-duration: 240ms\n  }\n  \n  .standard-menu-container .menu>ul li>ul>li:nth-last-child(n+3)>a,\n  .standard-menu-container ul.menu li>ul>li:nth-last-child(n+3)>a {\n      transition-duration: 360ms\n  }\n  \n  .standard-menu-container .menu>ul li>ul>li:nth-last-child(n+4)>a,\n  .standard-menu-container ul.menu li>ul>li:nth-last-child(n+4)>a {\n      transition-duration: 480ms\n  }\n  \n  .standard-menu-container .menu>ul li>ul>li:nth-last-child(n+5)>a,\n  .standard-menu-container ul.menu li>ul>li:nth-last-child(n+5)>a {\n      transition-duration: 600ms\n  }\n  \n  .standard-menu-container .menu>ul li:hover>ul>li>a,\n  .standard-menu-container ul.menu li:hover>ul>li>a {\n      opacity: 1;\n      transition-delay: 100ms\n  }\n  \n  .standard-menu-container .menu>ul li:hover>ul>li:nth-child(n+1)>a,\n  .standard-menu-container ul.menu li:hover>ul>li:nth-child(n+1)>a {\n      transition-duration: 120ms\n  }\n  \n  .standard-menu-container .menu>ul li:hover>ul>li:nth-child(n+2)>a,\n  .standard-menu-container ul.menu li:hover>ul>li:nth-child(n+2)>a {\n      transition-duration: 240ms\n  }\n  \n  .standard-menu-container .menu>ul li:hover>ul>li:nth-child(n+3)>a,\n  .standard-menu-container ul.menu li:hover>ul>li:nth-child(n+3)>a {\n      transition-duration: 360ms\n  }\n  \n  .standard-menu-container .menu>ul li:hover>ul>li:nth-child(n+4)>a,\n  .standard-menu-container ul.menu li:hover>ul>li:nth-child(n+4)>a {\n      transition-duration: 480ms\n  }\n  \n  .standard-menu-container .menu>ul li:hover>ul>li:nth-child(n+5)>a,\n  .standard-menu-container ul.menu li:hover>ul>li:nth-child(n+5)>a {\n      transition-duration: 600ms\n  }\n  \n  .standard-menu-container .menu>ul ul,\n  .standard-menu-container ul.menu ul {\n      position: absolute;\n      top: 100%;\n      left: 0;\n      text-align: left;\n      background: #2c3142;\n      padding: 15px 20px;\n      margin-top: 20px;\n      visibility: hidden;\n      min-width: 200px;\n      opacity: 0;\n      transition: all 400ms cubic-bezier(.445, .05, .55, .95)\n  }\n  \n  .standard-menu-container .menu>ul ul li a,\n  .standard-menu-container ul.menu ul li a {\n      position: relative;\n      color: #fff;\n      white-space: nowrap\n  }\n  \n  .standard-menu-container .menu>ul ul li a:after,\n  .standard-menu-container ul.menu ul li a:after {\n      background-color: #fff\n  }\n\n  .menu-item {\n    display: inline-flex;\n    align-items: stretch;\n    cursor: pointer;\n  }\n\n  .menu-item>a {\n    flex: 1;\n  }\n\n  .sub-menu li.menu-item {\n    width: 100%;\n    color: white;\n  }\n  .sub-menu li.menu-item>a>span {\n    color: white;\n  }\n\n  .menu-item-submenu-trigger {\n    width: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .menu-item-submenu-trigger:after {\n    content: \" \";\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 8px 6px 0 6px;\n    border-color: transparent;\n    border-top-color: #2c3142;\n  }\n\n  .sub-menu .menu-item-submenu-trigger:after {\n    border-width: 6px 0 6px 8px;\n    border-color: transparent transparent transparent white;    \n  }\n \n  .fullscreen-menu nav ul li.current-menu-ancestor>a:after,\n  .fullscreen-menu nav ul li.current-menu-item>a:after,\n  .fullscreen-menu nav ul li.current_page_ancestor>a:after,\n  .fullscreen-menu nav ul li.current_page_item>a:after,\n  .standard-menu-container .menu>ul ul li.current-menu-ancestor>a:after,\n  .standard-menu-container .menu>ul ul li.current-menu-item>a:after,\n  .standard-menu-container .menu>ul ul li.current_page_ancestor>a:after,\n  .standard-menu-container .menu>ul ul li.current_page_item>a:after,\n  .standard-menu-container .menu>ul ul li:hover>a:after,\n  .standard-menu-container ul.menu ul li.current-menu-ancestor>a:after,\n  .standard-menu-container ul.menu ul li.current-menu-item>a:after,\n  .standard-menu-container ul.menu ul li.current_page_ancestor>a:after,\n  .standard-menu-container ul.menu ul li.current_page_item>a:after,\n  .standard-menu-container ul.menu ul li:hover>a:after {\n      width: 100%\n  }\n  \n  .fullscreen-menu nav ul li,\n  .page-heading__description p~p,\n  .standard-menu-container .menu>ul ul li+li,\n  .standard-menu-container ul.menu ul li+li {\n      margin-top: 10px\n  }\n  \n  .standard-menu-container .menu>ul ul ul,\n  .standard-menu-container ul.menu ul ul {\n      left: 100%;\n      top: 0;\n      margin-top: 0;\n      margin-left: 21px\n  }\n  \n  .standard-menu-container .menu>ul ul.open-from-left,\n  .standard-menu-container ul.menu ul.open-from-left {\n      left: auto;\n      right: 0;\n      margin-left: 21px;\n      margin-right: 0\n  }\n  \n  .standard-menu-container .menu>ul ul .open-from-left,\n  .standard-menu-container .menu>ul ul.open-from-left ul,\n  .standard-menu-container ul.menu ul .open-from-left,\n  .standard-menu-container ul.menu ul.open-from-left ul {\n      left: auto;\n      right: 100%;\n      margin-right: 21px;\n      margin-left: 0\n  }\n  \n  .standard-menu-container.menu-skin-main .menu>ul ul,\n  .standard-menu-container.menu-skin-main ul.menu ul {\n      background: #2c3142\n  }\n  \n  .standard-menu-container.menu-skin-dark .menu>ul ul li a:after,\n  .standard-menu-container.menu-skin-dark ul.menu ul li a:after,\n  .standard-menu-container.menu-skin-main .menu>ul ul li a:after,\n  .standard-menu-container.menu-skin-main ul.menu ul li a:after {\n      background-color: #fff\n  }\n  \n  .standard-menu-container.menu-skin-dark .menu>ul>li>a,\n  .standard-menu-container.menu-skin-dark ul.menu>li>a {\n      color: #333\n  }\n  \n  .standard-menu-container.menu-skin-dark .menu>ul>li>a:after,\n  .standard-menu-container.menu-skin-dark ul.menu>li>a:after,\n  .standard-menu-container.menu-skin-light .menu>ul ul li a:after,\n  .standard-menu-container.menu-skin-light ul.menu ul li a:after {\n      background-color: #333\n  }\n  \n  .standard-menu-container.menu-skin-dark .menu>ul ul,\n  .standard-menu-container.menu-skin-dark ul.menu ul {\n      background: #333\n  }\n  \n  .fullscreen-menu nav ul li a:hover,\n  .standard-menu-container.menu-skin-dark .menu>ul ul li a,\n  .standard-menu-container.menu-skin-dark ul.menu ul li a,\n  .standard-menu-container.menu-skin-light .menu>ul>li>a,\n  .standard-menu-container.menu-skin-light ul.menu>li>a {\n      color: #fff\n  }\n  \n  .standard-menu-container.menu-skin-light .menu>ul>li>a:after,\n  .standard-menu-container.menu-skin-light ul.menu>li>a:after {\n      background-color: #fff\n  }\n  \n  .standard-menu-container.menu-skin-light .menu>ul ul,\n  .standard-menu-container.menu-skin-light ul.menu ul {\n      background: #fff\n  }\n  \n  .standard-menu-container.menu-skin-light .menu>ul ul li a,\n  .standard-menu-container.menu-skin-light ul.menu ul li a {\n      color: #333\n  }\n  \n  .header-search-input {\n      position: relative;\n      display: block;\n      text-align: left;\n      pointer-events: auto;\n      align-self: center;\n      top: 2px;\n      z-index: 400\n  }\n  \n  .header-search-input .search-field {\n      position: absolute;\n      display: block;\n      right: -10px;\n      background: #ededed;\n      margin: 0;\n      z-index: 5;\n      border-radius: 3px;\n      padding: 8px 6px 8px 10px;\n      top: 50%;\n      transform: translateY(-58%);\n      visibility: hidden;\n      opacity: 0;\n  }\n  \n  .header-search-input .search-field span {\n      display: block;\n      min-width: 200px;\n      opacity: .8;\n      min-height: 20px;\n  }\n  \n  .header-search-input .search-field input {\n      left: 0;\n      top: 50%;\n      transform: translateY(-50%);\n      position: absolute;\n      background: 0 0;\n      border: 0;\n      max-width: 80%;\n      padding-left: 10px;\n      box-shadow: none\n  }\n  \n  .header-search-input .search-field input:focus {\n      box-shadow: none;\n      outline: 0\n  }\n  \n  .header-search-input .search-icon {\n      position: relative;\n      z-index: 10;\n      text-align: center;\n      margin-top: 0\n  }\n  \n  .header-search-input .search-icon a svg {\n      width: 22px;\n      height: 22px;\n      transition: fill 150ms ease-in-out\n  }\n  \n  .header-search-input--align-right .search-field {\n      left: -10px;\n      right: auto\n  }\n  \n  .header-search-input--align-right .search-field span {\n      padding-left: 30px\n  }\n  \n  .header-search-input--align-right .search-field input {\n      padding-left: 40px;\n      padding-right: 10px;\n      width: 100%;\n      max-width: 100%\n  }\n  \n  .header-search-input--input-visible .search-field {\n      visibility: visible;\n      opacity: 1;\n      position: relative;\n      transform: none;\n      top: 0;\n      right: 0;\n      left: 0\n  }\n  \n  .header-search-input--input-visible .search-icon {\n      position: absolute;\n      top: 50%;\n      right: 10px;\n      transform: translateY(-50%);\n      height: 15px\n  }\n  \n  .header-search-input--input-visible.header-search-input--align-right .search-field span {\n      padding-left: 25px\n  }\n  \n  .header-search-input--input-visible.header-search-input--align-right .search-field input {\n      padding-left: 33px;\n      padding-right: 8px\n  }\n  \n  .header-search-input--input-visible.header-search-input--align-right .search-icon {\n      left: 10px;\n      right: auto\n  }\n  \n  .header-search-input--input-visible.menu-skin-light .search-field input,\n  .header-search-input--input-visible.menu-skin-light .search-field span {\n      color: #fff\n  }\n  \n  .header-search-input--input-visible.menu-skin-dark .search-field input,\n  .header-search-input--input-visible.menu-skin-dark .search-field span,\n  .header-search-input.menu-skin-dark .search-icon a,\n  .search-results-holder .result-box .result-info h3 a {\n      color: #333\n  }\n  \n  .header-search-input.menu-skin-main .search-icon a svg {\n      fill: #2c3142\n  }\n  \n  .header-search-input.menu-skin-dark .search-icon a svg {\n      fill: #333\n  }\n  \n  .header-search-input.menu-skin-light .search-icon a {\n      color: #fff\n  }\n  \n  .header-search-input.menu-skin-light .search-icon a svg {\n      fill: #fff\n  }\n  \n  .header-search-input.menu-skin-light.search-field-visible .search-icon svg {\n      transition: fill 350ms ease-in-out;\n      fill: #333\n  }\n    .header-logo.logo-text {\n      color: #2c3142;\n    }\n    .fullscreen-menu.menu-skin-main {\n      background-color: #2c3142;\n    }\n    .fullscreen-menu.fullscreen-menu.menu-skin-main.translucent-background {\n      background-color: rgba(44,49,66,0.9);\n    }\n    .standard-menu-container.menu-skin-main ul.menu > li > a {\n      color: #2c3142;\n    }\n    .standard-menu-container.menu-skin-main ul.menu > li > a:after {\n      background-color: #2c3142;\n    }\n    .toggle-bars.menu-skin-main .toggle-bars__bar-line {\n      background-color: #2c3142;\n    }\n    .toggle-bars.menu-skin-main .toggle-bars__text {\n      color: #2c3142;\n    }\n    .standard-menu-container.menu-skin-main ul.menu ul {\n      background-color: #2c3142;\n      z-index: 999;\n    }\n    .fullscreen-menu .fullscreen-menu-footer .social-networks li a i {\n      color: #2c3142;\n    }\n    .header-logo.logo-text.menu-skin-main .logo-text {\n      color: #2c3142;\n    }\n  \n    .top-header-bar .raw-text-widget.menu-skin-main {\n      color: #2c3142;\n    }\n    .header-search-input.menu-skin-main .search-field span,\n    .header-search-input.menu-skin-main .search-field input {\n      color: #2c3142;\n    }\n  \n  \n  @media screen and (max-width: 768px){\n      .header-block__item--standard-menu-container {\n          display: none;\n      }\n      .toggle-bars span {\n          display: block;\n      }\n  }\n  \n  \n  @media (min-width: 768px) {\n      .container, .content-area {\n          width: 750px;\n      }\n  }\n  \n  @media (min-width: 992px) {\n      .container, .content-area {\n          width: 970px;\n      }\n  }\n  \n  @media (min-width: 1200px) {\n      .container, .content-area {\n          width: 1170px;\n      }\n  }\n\n  \n  .hover-underline-animation {\n      display: inline-block;\n      position: relative;\n      color: #2c3142;\n  }\n\n  .nav-container-main-menu li span,\n  .nav-link-span {\n    font-family: 'NTR', sans-serif !important;\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 1.33333333;\n    margin: 0 1px;\n  }\n  \n  .hover-underline-animation:after {\n      content: '';\n      position: absolute;\n      width: 100%;\n      transform: scaleX(0);\n      height: 2px;\n      bottom: 0;\n      left: 0;\n      background-color: #2c3142;\n      transform-origin: bottom left;\n      transition: transform 0.25s ease-out;\n  }\n  \n  .hover-underline-animation:hover:after {\n      transform: scaleX(1);\n      transform-origin: bottom left;\n  }\n  \n  .sub-menu .hover-underline-animation:after {\n      content: '';\n      position: absolute;\n      width: 100%;\n      transform: scaleX(0);\n      height: 2px;\n      bottom: 0;\n      left: 0;\n      background-color: #ffffff;\n      transform-origin: bottom left;\n      transition: transform 0.25s ease-out;\n  }\n  \n  .sub-menu .hover-underline-animation:hover:after {\n      transform: scaleX(1);\n      transform-origin: bottom left;\n  }\n\n\n  .info-btn svg {\n      height: 26px;\n      vertical-align: middle;\n  }\n  \n  \n  footer.site-footer {\n    background-color: #932525;\n    color: #fff;\n  }\n  \n  \n  .site-footer.fixed-footer {\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1;\n    margin-left: 0;\n    margin-right: 0;\n  }\n  \n  @media screen and (max-width: 992px) {\n    .site-footer.fixed-footer {\n        position: fixed;\n        bottom: 0;\n        margin-left: 0;\n        margin-right: 0;\n    }\n  }\n  \n  footer.site-footer {\n    transition: transform 400ms cubic-bezier(.445,.05,.55,.95);\n  }   \n  \n  .site-footer {\n    position: fixed;\n    bottom: 0;\n    z-index: -10;\n    background-color: #eee;\n  }\n  \n  .site-footer.footer-bottom-horizontal .footer-bottom-content {\n    display: table;\n    table-layout: auto;\n    width: 100%;\n  }\n  \n  .site-footer .footer-bottom-content {\n    padding-top: 30px;\n    padding-bottom: 30px;\n  }\n  \n  #footer p {\n    font-size: 14px;\n    font-weight: 400;\n  }\n  \n  .app-container-wrapper {\n      margin-top: 2px;\n      margin-bottom: 120px;\n  }\n\n  \n:root {\n    --primary:#2c3142;\n    --danger: #932525;\n    --info:#0c5460;\n    --secondry: #C2C4C9;\n}\n\n.btn-primary {\n    background-color: var(--primary);\n    border-color: #12151C;\n}\n\n.btn-primary:hover,\n.btn-primary:active,\n.btn-primary:focus,\n.btn-primary:visited {\n    background-color: #1F232F !important;\n    border-color: #0D0F14;\n}\n\n.btn-primary.disabled.focus, \n.btn-primary.disabled:focus, \n.btn-primary.disabled:hover, \n.btn-primary[disabled].focus, \n.btn-primary[disabled]:focus, \n.btn-primary[disabled]:hover, \nfieldset[disabled] .btn-primary.focus, \nfieldset[disabled] .btn-primary:focus, \nfieldset[disabled] .btn-primary:hover {\n    border-color: #161921;\n}\n\n.btn-danger {\n    background-color: var(--danger);\n    border-color: #6E0000;\n}\n\n.btn-danger:hover,\n.btn-danger:active,\n.btn-danger:focus,\n.btn-danger:visited {\n    background-color: #691A1A !important;\n    border-color: #541515 !important;\n}\n\n.btn-danger.disabled.focus, \n.btn-danger.disabled:focus, \n.btn-danger.disabled:hover, \n.btn-danger[disabled].focus, \n.btn-danger[disabled]:focus, \n.btn-danger[disabled]:hover, \nfieldset[disabled] .btn-danger.focus, \nfieldset[disabled] .btn-danger:focus, \nfieldset[disabled] .btn-danger:hover {\n    border-color:#822424;\n}\n\n.progress-bar {\n    background-color: var(--primary);\n}\n\n.alert {\n    margin: 1rem auto;\n    padding: .75rem 1.25rem;\n    border: 1px solid transparent;\n    border-radius: 0.25rem;\n}\n\n.alert-secondary {\n    color: #2C3142 ;\n    background-color: var(--secondry);\n    border-color: #d6d8db;\n}\n\n.alert-success {\n    color: var(--primary) !important;\n    background-color: #C2C4C9 !important;\n}\n\n.alert-danger {\n    color: var(--danger) !important;\n    background-color: #E0C0C0 !important;\n}\n\n.success-redirect-msg a {\n    color: #000a2d;\n    text-decoration: none; \n}\n\n.success-redirect-msg a:hover { \n    color: #000a2d; \n    text-decoration: underline; \n} \n\n.form-control:focus {\n    border-color: var(--primary);\n    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px #0b273e99;\n    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px #0b273e99;\n}\n\ninput[type=\"checkbox\"]:checked{\n   filter: invert(1%) sepia(40%) saturate(100%) hue-rotate(0) \n   brightness(68%) contrast(250%);\n   -webkit-filter: invert(1%) sepia(40%) saturate(100%) hue-rotate(0) \n   brightness(68%) contrast(250%)\n}";
styleInject(css_248z);

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function BrowserWarning(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? 'Supported browsers are Chrome, Firefox & Microsoft Edge. Please contact support at 800-969-7001 for any issues.' : _ref$text;
  return React.createElement("div", {
    className: "container"
  }, React.createElement("p", {
    className: "alert alert-secondary"
  }, text));
}

/* eslint-disable no-restricted-globals */
function attachWindowEvents() {
  var pushState = history.pushState;
  var replaceState = history.replaceState;
  history.pushState = function () {
    //@ts-ignore
    pushState.apply(history, arguments);
    window.dispatchEvent(new Event('pushstate'));
    window.dispatchEvent(new Event('locationchange'));
  };
  history.replaceState = function () {
    //@ts-ignore
    replaceState.apply(history, arguments);
    window.dispatchEvent(new Event('replacestate'));
    window.dispatchEvent(new Event('locationchange'));
  };
  window.addEventListener('popstate', function () {
    window.dispatchEvent(new Event('locationchange'));
  });
}

attachWindowEvents();
var NO_SUB_MENU = -1;
var AppContainer = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AppContainer, _Component);
  function AppContainer(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.onSubmit = function (e) {
      var _this$state = _this.state,
        searchQuery = _this$state.searchQuery,
        showSearchInput = _this$state.showSearchInput;
      e.preventDefault();
      if (searchQuery && showSearchInput) {
        window.open("https://prcousa.com/?s=" + searchQuery, '_self');
      } else {
        _this.setState({
          showSearchInput: !showSearchInput
        });
      }
    };
    _this.redirectToHome = function (e) {
      e.preventDefault();
      window.history.pushState({}, '', '/');
      var navEvent = new PopStateEvent('popstate');
      window.dispatchEvent(navEvent);
    };
    _this.handleMenuClick = function (event) {
      var target = event.target;
      if (!(target instanceof HTMLElement)) return undefined;
      var anchor = target.closest('a');
      var anchorHref = anchor == null ? void 0 : anchor.getAttribute("href");
      if (anchorHref === '#') event.preventDefault();else if (anchorHref) return _this.setState({
        showSubMenu: NO_SUB_MENU,
        showNestedSubMenu: NO_SUB_MENU
      });
      var item = target.closest('.menu-item');
      if (!(item instanceof HTMLElement)) return undefined;
      var menuPath = item.dataset.menuPath;
      if (!menuPath) return undefined;
      var _menuPath$split$map = menuPath.split('.').map(function (i) {
          return parseInt(i, 10);
        }),
        clickedMenu = _menuPath$split$map[0],
        _menuPath$split$map$ = _menuPath$split$map[1],
        clickedSubMenu = _menuPath$split$map$ === void 0 ? NO_SUB_MENU : _menuPath$split$map$;
      var _this$state2 = _this.state,
        currentMenu = _this$state2.showSubMenu,
        currentSubMenu = _this$state2.showNestedSubMenu;
      if (clickedSubMenu === NO_SUB_MENU) _this.setState({
        showSubMenu: clickedMenu !== currentMenu ? clickedMenu : NO_SUB_MENU,
        showNestedSubMenu: NO_SUB_MENU
      });else if (currentMenu === clickedMenu && currentSubMenu === clickedSubMenu) _this.setState({
        showSubMenu: clickedMenu ? clickedMenu : NO_SUB_MENU,
        showNestedSubMenu: NO_SUB_MENU
      });else _this.setState({
        showSubMenu: clickedMenu,
        showNestedSubMenu: clickedSubMenu
      });
      return undefined;
    };
    _this.state = {
      showSearchInput: false,
      searchQuery: '',
      showSubMenu: NO_SUB_MENU,
      showNestedSubMenu: NO_SUB_MENU,
      navMenu: [],
      location: window.location.href
    };
    return _this;
  }
  var _proto = AppContainer.prototype;
  _proto.onLocationChange = function onLocationChange() {
    this.setState({
      location: window.location.href
    });
  };
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    window.addEventListener('click', function (event) {
      if (_this2.state.showSubMenu === NO_SUB_MENU) return undefined;
      var target = event.target;
      if (!(target instanceof HTMLElement)) return undefined;
      if (!target.closest('.menu-item')) _this2.setState({
        showSubMenu: NO_SUB_MENU,
        showNestedSubMenu: NO_SUB_MENU
      });
      return undefined;
    });
    try {
      var getMenuOptions = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var apiUrl, domain, menuOptionsApiUrl, response, data;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                apiUrl = _this2.props.apiUrl;
                domain = window.location.origin;
                menuOptionsApiUrl = apiUrl && apiUrl !== '/' ? apiUrl : domain + "/api/menu-options";
                _context.next = 5;
                return fetch(menuOptionsApiUrl);
              case 5:
                response = _context.sent;
                _context.next = 8;
                return response.json();
              case 8:
                data = _context.sent;
                _this2.setState({
                  navMenu: data
                });
              case 10:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function getMenuOptions() {
          return _ref.apply(this, arguments);
        };
      }();
      getMenuOptions();
      window.addEventListener('locationchange', this.onLocationChange.bind(this));
    } catch (error) {
      console.error(error);
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('locationchange', this.onLocationChange.bind(this));
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props = this.props,
      children = _this$props.children,
      headerChildren = _this$props.headerChildren,
      token = _this$props.token,
      onLogoutClick = _this$props.onLogoutClick,
      _this$props$showBrows = _this$props.showBrowserWarning,
      showBrowserWarning = _this$props$showBrows === void 0 ? true : _this$props$showBrows,
      browserWarningText = _this$props.browserWarningText,
      showInfoIcon = _this$props.showInfoIcon,
      onInfoIconCLicked = _this$props.onInfoIconCLicked;
    var _this$state3 = this.state,
      navMenu = _this$state3.navMenu,
      showSubMenu = _this$state3.showSubMenu,
      showNestedSubMenu = _this$state3.showNestedSubMenu,
      showSearchInput = _this$state3.showSearchInput,
      searchQuery = _this$state3.searchQuery,
      location = _this$state3.location;
    var showReturnToDashboardLink = location.split(/\?/g)[0] !== window.location.origin + "/";
    return React.createElement(Fragment, null, React.createElement("div", {
      className: "header-block"
    }, React.createElement("div", {
      className: "header-block__row-container container"
    }, React.createElement("div", {
      className: "header-block__row header-block__row--main"
    }, React.createElement("div", {
      className: "header-block__column header-block__logo header-block--auto-grow"
    }, React.createElement("style", {
      "data-appended-custom-css": "true",
      dangerouslySetInnerHTML: {
        __html: '.logo-image {width:159px;height:48px;}'
      }
    }), ' ', React.createElement("a", {
      href: "/",
      className: "header-logo",
      onClick: this.redirectToHome
    }, React.createElement("img", {
      src: "https://prcousa.com/wp-content/uploads/PRcoPowerLogorb.png",
      className: "main-logo logo-image",
      width: 159,
      height: 159,
      alt: ""
    }), showReturnToDashboardLink ? React.createElement("span", {
      className: "nav-link-span hover-underline-animation"
    }, React.createElement("svg", {
      "aria-hidden": "true",
      focusable: "false",
      "data-prefix": "fas",
      "data-icon": "arrow-left",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512"
    }, React.createElement("path", {
      fill: "currentColor",
      d: "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    })), "Return to Dashboard") : React.createElement(React.Fragment, null))), React.createElement("div", {
      className: "header-block__column header-block--content-right header-block--align-right"
    }, React.createElement("div", {
      className: "header-block__items-row"
    }, React.createElement("div", {
      className: "header-block__item header-block__item--type-menu-main-menu header-block__item--standard-menu-container"
    }, React.createElement("div", {
      className: "standard-menu-container menu-skin-main"
    }, React.createElement("nav", {
      className: "nav-container-main-menu"
    }, React.createElement("ul", {
      id: "menu-home-1",
      className: "menu",
      onClick: this.handleMenuClick
    }, navMenu != null && navMenu.length ? navMenu.map(function (menu, i) {
      return React.createElement("li", {
        key: i,
        className: "menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children",
        "data-menu-path": "" + i
      }, React.createElement("a", {
        href: menu.url
      }, React.createElement("span", {
        className: "hover-underline-animation"
      }, menu.label)), menu.subMenu.length > 0 && React.createElement("span", {
        className: "menu-item-submenu-trigger"
      }), menu.subMenu.length ? React.createElement("ul", {
        className: "sub-menu",
        style: i === showSubMenu ? {
          opacity: 1,
          visibility: 'visible'
        } : {}
      }, menu.subMenu.map(function (subMenu, index) {
        return React.createElement("li", {
          key: index,
          className: "menu-item menu-item-type-custom menu-item-object-custom menu-item " + (subMenu.subMenu.length ? 'menu-item-has-children' : ''),
          "data-menu-path": i + "." + index
        }, React.createElement("a", {
          href: subMenu.url
        }, React.createElement("span", {
          className: "hover-underline-animation"
        }, subMenu.label)), subMenu.subMenu.length > 0 && React.createElement("span", {
          className: "menu-item-submenu-trigger"
        }), subMenu.subMenu.length ? React.createElement("ul", {
          className: "sub-menu",
          style: index === showNestedSubMenu ? {
            opacity: 1,
            visibility: 'visible'
          } : {}
        }, subMenu.subMenu.map(function (nestedSubMenu, index2) {
          return React.createElement("li", {
            key: index2,
            className: "menu-item menu-item-type-custom menu-item-object-custom menu-item"
          }, React.createElement("a", {
            href: nestedSubMenu.url
          }, React.createElement("span", {
            className: "hover-underline-animation"
          }, nestedSubMenu.label)));
        })) : null);
      })) : null);
    }) : null, React.createElement("li", {
      className: "menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item"
    }, !!token && React.createElement("a", {
      href: "#/"
    }, React.createElement("span", {
      "data-testid": "logout-btn",
      onClick: onLogoutClick
    }, "Logout"))), React.createElement("li", {
      className: "menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item"
    }, !!showInfoIcon && React.createElement("a", {
      href: "#/"
    }, React.createElement("span", {
      onClick: onInfoIconCLicked,
      className: "info-btn"
    }, React.createElement("svg", {
      "aria-hidden": "true",
      focusable: "false",
      "data-prefix": "fas",
      "data-icon": "info-circle",
      className: "svg-inline--fa fa-info-circle fa-w-16 ",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512"
    }, React.createElement("path", {
      fill: "currentColor",
      d: "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
    }))))))))), headerChildren && React.createElement("div", {
      className: "header-block__item"
    }, headerChildren), React.createElement("div", {
      className: "header-block__item header-block__item--type-search-field header-block__item--hide-on-mobile"
    }, React.createElement("div", {
      className: "header-search-input menu-skin-main"
    }, React.createElement("form", {
      role: "search",
      onSubmit: this.onSubmit
    }, React.createElement("div", {
      className: "search-field",
      style: showSearchInput ? {
        opacity: 1,
        visibility: 'visible'
      } : {}
    }, React.createElement("span", null), React.createElement("input", {
      type: "search",
      value: searchQuery,
      autoComplete: "off",
      name: "s",
      placeholder: "Search site...",
      onChange: function onChange(e) {
        return _this3.setState({
          searchQuery: e.target.value
        });
      }
    })), React.createElement("div", {
      className: "search-icon",
      onClick: this.onSubmit
    }, React.createElement("a", {
      href: "#/",
      "data-animation": "none"
    }, React.createElement("svg", {
      height: 24,
      width: 24,
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 1417.3 1417.3",
      // style={{ enableBackground: "new 0 0 1417.3 1417.3" }}
      xmlSpace: "preserve"
    }, React.createElement("style", {
      type: "text/css",
      dangerouslySetInnerHTML: {
        __html: '\n\t.st0{display:none;}\n\t.st1{display:inline;}\n'
      }
    }), React.createElement("g", {
      id: "search-one"
    }, React.createElement("path", {
      d: "M976.2,925.2c90.6-98.1,147.1-229.4,147.1-374.1C1123.4,247.7,876.5,0,572.2,0S21.1,247.7,21.1,551.1\n              s246.9,551.1,551.1,551.1c123.9,0,237.7-40.7,330-109.7l409.8,409.8c10,10,22.4,15,34.9,15s25.8-5,34.9-15\n              c19.1-19.1,19.1-50.7,0-70.7L976.2,925.2z M120.8,551.1c0-248.6,202-451.4,451.4-451.4c248.6,0,451.4,202,451.4,451.4\n              s-202,451.4-451.4,451.4S120.8,799.7,120.8,551.1z"
    })), React.createElement("g", {
      id: "search-two",
      className: "st0"
    }, React.createElement("path", {
      className: "st1",
      d: "M976.2,925.2c90.6-98.1,147.1-229.4,147.1-374.1C1123.4,247.7,876.5,0,572.2,0S21.1,247.7,21.1,551.1\n              s246.9,551.1,551.1,551.1c123.9,0,237.7-40.7,330-109.7l409.8,409.8c10,10,22.4,15,34.9,15s25.8-5,34.9-15\n              c19.1-19.1,19.1-50.7,0-70.7L976.2,925.2z"
    }))))))))))))), React.createElement("div", {
      className: "app-container-wrapper"
    }, showBrowserWarning ? React.createElement(BrowserWarning, {
      text: browserWarningText
    }) : React.createElement(React.Fragment, null), children), React.createElement("footer", {
      id: "footer",
      role: "contentinfo",
      className: "site-footer main-footer footer-bottom-horizontal fixed-footer site-footer-inverted main-footer-inverted"
    }, React.createElement("div", {
      className: "footer-bottom"
    }, React.createElement("div", {
      className: "container"
    }, React.createElement("div", {
      className: "footer-bottom-content"
    }, React.createElement("div", {
      className: "footer-content-left"
    }, React.createElement("div", {
      className: "copyrights site-info"
    }, React.createElement("p", null, "\xA9 PRco inc. ", new Date().getFullYear()))))))));
  };
  return AppContainer;
}(Component);

export { AppContainer };
//# sourceMappingURL=react-common.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./vendor/react-common/dist/react-common.esm.js
// module id = 520
// module chunks = 0